module.exports = __webpack_public_path__ + "static/media/sign-in-with-google.1ce1aaa5.png";